import { Component, OnInit } from '@angular/core';
import { MultistepsService } from '@app/modules/applicant/base';
import { SessionService, StepsIdEnum, LookupsService } from '@app/base/core';
import { FormGroup } from '@angular/forms';
import { CanComponentDeactivate, compareObjects } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AlertService} from '@app/base/alerts/alert.service';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit, CanComponentDeactivate {
  form: FormGroup;
  alertMsg: any = [];
  latLng: {} = null;
  sryNotification: any;
  serviceAddress: any = {};
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  constructor(public wizardSvc: MultistepsService, public sessionSvc: SessionService, private lookupSvc: LookupsService,
     public alertService: AlertService, public browser: PlatformLocation) {
    this.wizardSvc.syncActiveStep(StepsIdEnum.LOCATION);
  }

  ngOnInit() {
    this.browser.onPopState(() => {
      let url = window.location.href;
      url = url.replace('review', 'location');
      window.history.pushState(null, '', url);
    });
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.LOCATION).form;

  // Load common lookup values
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      // Loading banner message for Location
       if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Location'
        ));
        this.alertService.info(this.alertMsg.message);
      }
    });
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.LOCATION).form;
    // SryNotification variable is to pass the custom error message from database to Custom-map.Component.ts
    this.sryNotification = this.lookupSvc.messages.filter(a => a.messageType === 'Error');
    this.latLng = {
      lat: this.wizardSvc.serviceAddress != null ? this.wizardSvc.serviceAddress.latitude : this.sessionSvc.activeLdc.latitude,
      lng: this.wizardSvc.serviceAddress != null ? this.wizardSvc.serviceAddress.longitude : this.sessionSvc.activeLdc.longitude,
      zoom: this.wizardSvc.serviceAddress != null ? this.wizardSvc.serviceAddress.zoomLevel : this.sessionSvc.activeLdc.mapZoom,
      showMarker: Boolean(this.wizardSvc.serviceAddress),
    };
  }
  next() { this.wizardSvc.nextStep(); } // To go to Next step
  back() { this.wizardSvc.previousStep(); } // To go to Previous step

  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    if (this.wizardSvc.maxCompletedStep < 1) { return true; } // User didn't complete any step, so they can leave.
    return this.wizardSvc.canDeactivateStep(route, state, nextState);
  }

  getServiceAddress($event) {
    // If address is null or different than currently stored address update it and reload it from server.
    // if (!this.wizardSvc.serviceAddress || !compareObjects(this.wizardSvc.serviceAddress, $event)) {
      // TODO: uncheck same as service address and clear mailing address data.
      this.wizardSvc.addressValidationDone = false;
      this.wizardSvc.addressChanged = true;
      this.wizardSvc.serviceAddress = $event;
      this.serviceAddress.state = this.wizardSvc.serviceAddress.state.short_name;
      this.serviceAddress.city = this.wizardSvc.serviceAddress.city;
      this.serviceAddress.county = this.wizardSvc.serviceAddress.county;
      this.serviceAddress.zip = this.wizardSvc.serviceAddress.zip;
      if (this.form.controls['locationStreetName'].value !== null && this.form.controls['locationStreetName'].value !== '' &&
        this.form.controls['locationStreetName'].value !== undefined) {
        this.serviceAddress.streetName = this.form.controls['locationStreetName'].value;
      } else {
        this.serviceAddress.streetName = this.wizardSvc.serviceAddress.street_name;
      }
      if (this.form.controls['locationStreetNumber'].value !== null && this.form.controls['locationStreetNumber'].value !== '' &&
        this.form.controls['locationStreetNumber'].value !== undefined) {
        this.serviceAddress.streetNumber = this.form.controls['locationStreetNumber'].value;
      } else {
        this.serviceAddress.streetNumber = this.wizardSvc.serviceAddress.street_number;
      }
      this.serviceAddress.propertyType = this.wizardSvc.paramRequestType;
      this.lookupSvc.resolveServiceAddressLookups(
        this.serviceAddress);

      const subscription = this.lookupSvc.serviceAddressLookupsLoaded$.subscribe(loaded => {
        if (loaded) {
          subscription.unsubscribe();
          this.wizardSvc.steps[StepsIdEnum.TYPE].form.reset();
          this.wizardSvc.duplicatedRequest = false;
          this.wizardSvc.maxCompletedStep = StepsIdEnum.TYPE;
          this.next();
        }
      });
    // } else { this.next(); }
  }
}
